module.exports = __webpack_public_path__ + "img/1995-Antenne-Steiermark.475c64a3.jpg";